import { State } from './../state';
import { IAdminDevicesState } from './state';
import { getStoreAccessors } from 'typesafe-vuex';


export const getters = {
    getDevices: (state: IAdminDevicesState) => state.devices,
};

export const { read } = getStoreAccessors<IAdminDevicesState, State>('');
export const readDevices = read(getters.getDevices);


